"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicSlider = undefined;

var _basicSlider = require("./basicSlider");

var _basicSlider2 = _interopRequireDefault(_basicSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BasicSlider = _basicSlider2.default;